module.exports = __webpack_public_path__ + "img/sociability.6b389afb.png";